<script>
  import { v4 as uuidv4 } from "uuid"
  import { users } from "../lib/firebase"
  import { me } from "../store"

  let name = ""
  async function handleSubmit() {
    const id = uuidv4()
    const meObj = { id: uuidv4(), name }
    await users.doc(id).set(meObj)
    localStorage.setItem("me", JSON.stringify(meObj))
    me.set(meObj)
  }
</script>

<style lang="scss">
  @import "../vars";
  .shell {
    width: 48rem;
    margin: 6rem auto 0;
    position: relative;
    @include below(tablet) {
      margin-top: 4rem;
      width: 100%;
    }
    @include below(bigphone) {
      margin-top: 1rem;
    }
    @media (max-height: 1100px) {
      margin-top: 3rem;
    }
    @media (max-height: 900px) {
      margin-top: 1rem;
    }
  }
  .content {
    background: #fff;
    padding: 2rem;
    @include below(bigphone) {
      padding: 1rem;
    }
  }
  p {
    font-size: 1.4rem;
    line-height: 145%;
  }
  h1 {
    text-align: center;
  }
  label {
    display: block;
    margin-bottom: 0.3rem;
  }
  button {
    background: $orange;
    color: $white;
    font-size: 1rem;
    padding: 0.45rem 1.3rem;
    border: 0;
  }
  form {
    padding: 3rem;
    background: $gray;
  }
</style>

<div class="shell">
  <h1>Let's Get Started!</h1>
  <div class="content">
    <p>
      Ready to play a fun game of spontaneous creation with your fellow WDS
      Attendees?
    </p>
    <form on:submit|preventDefault={handleSubmit}>
      <label>To start, enter your name below:</label>
      <input type="text" placeholder="Your Name" bind:value={name} />
      <button type="submit">Let's Go!</button>
    </form>
  </div>
</div>
